import React, { useState } from 'react';
import { CaptureOverlay } from '../shared';

interface PhotoNotesProps {
  taskName: string;
  photos: string[];
  onAddMore: () => void;
  onSubmit: (notes: string) => void;
  onSaveDraft: (notes: string) => void;
  onClose: () => void;
  initialNotes?: string;
}

const MAX_CHARS = 2000;

export const PhotoNotes: React.FC<PhotoNotesProps> = ({
  taskName,
  photos,
  onAddMore,
  onSubmit,
  onSaveDraft,
  onClose,
  initialNotes,
}) => {
  const [notes, setNotes] = useState(initialNotes || '');

  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className="co-sheet">
        <div className="co-sheet-handle" />
        <div className="co-sheet-head">
          <div className="co-sheet-title">Add a Note</div>
        </div>

        <div className="co-sheet-body">
          {/* Attached photos strip */}
          <div>
            <div className="co-attached-label">Attached Photos</div>
            <div className="pc-notes-strip">
              {photos.map((p, i) => (
                <div key={i} className="pc-notes-strip-thumb">
                  <img src={p} alt={`Photo ${i + 1}`} />
                </div>
              ))}
              <div className="pc-notes-strip-add" onClick={onAddMore}>+</div>
            </div>
          </div>

          {/* Notes textarea */}
          <div className="co-note-wrap">
            <div className="co-note-label">Optional note</div>
            <textarea
              className="co-textarea"
              placeholder="Add context, reactions, or anything else…"
              rows={3}
              value={notes}
              onChange={e => setNotes(e.target.value.slice(0, MAX_CHARS))}
            />
            <div className="co-charcount">{notes.length} / {MAX_CHARS}</div>
          </div>
        </div>

        <div className="co-sheet-actions">
          <button className="co-btn-ember" onClick={() => onSubmit(notes)}>
            Submit Task
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
              <polyline points="20,6 9,17 4,12" />
            </svg>
          </button>
          <button className="co-btn-ghost" onClick={() => onSaveDraft(notes)}>
            Save Draft
          </button>
        </div>
      </div>
    </CaptureOverlay>
  );
};
